// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RenderRowTabAttributesTable_RenderRowTabAttributesTable__H5Kqm {
  display: flex;
  align-items: center;
  background-color: #ffffff;
  max-height: calc(100vh - 421px);
  overflow: auto;
}
.RenderRowTabAttributesTable_RenderRowTabAttributesTable__H5Kqm:hover {
  background-color: #def3db;
  text-decoration-line: underline;
  cursor: pointer;
}
.RenderRowTabAttributesTable_RenderRowTabAttributesTable__H5Kqm:hover div div {
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}
.RenderRowTabAttributesTable_RenderRowTabAttributesTable__H5Kqm:hover__titleFirst + .RenderRowTabAttributesTable_RenderRowTabAttributesTable__H5Kqm:hover__titleSecond + .RenderRowTabAttributesTable_RenderRowTabAttributesTable__H5Kqm:hover__titleThird {
  text-decoration: underline;
}

.RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleFirst__HT-sn {
  width: 29px;
  font-family: Raleway;
  text-transform: none;
  font-feature-settings: "lnum";
  display: table-cell;
  vertical-align: inherit;
  text-align: left;
  padding: 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
}

.RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleSecond__WzcKM {
  width: 100%;
  font-family: Raleway;
  text-transform: none;
  font-feature-settings: "lnum";
  display: table-cell;
  vertical-align: inherit;
  text-align: left;
  padding: 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
}

.RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleThird__mSVNI {
  font-family: Raleway;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  text-transform: none;
  font-feature-settings: "lnum";
  display: table-cell;
  text-align: left;
  border: 0px;
  color: inherit;
  vertical-align: middle;
}
.RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleThird__mSVNI div p {
  width: 29px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleFourth__JuWTu {
  font-family: Raleway;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.43;
  text-transform: none;
  font-feature-settings: "lnum";
  display: table-cell;
  text-align: left;
  border: 0px;
  color: inherit;
  padding: 8px 16px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/components/Administering/ModelEvaluation/ModelEvaluationDetail/ModelEvaluationDetailTab/ModelEvaluationDetailTabAttributes/RenderRowTabAttributesTable.module.scss","webpack://./src/constants/_colors.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,yBCJI;EDKJ,+BAAA;EACA,cAAA;AADJ;AAEI;EACI,yBCLK;EDML,+BAAA;EACA,eAAA;AAAR;AAEY;EACI,UAAA;EACA,oCAAA;AAAhB;AAGQ;EACI,0BAAA;AADZ;;AAKA;EACI,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAFJ;;AAIA;EACI,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADJ;;AAGA;EACI,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;AAAJ;AAEQ;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAZ;;AAIA;EACI,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AADJ","sourcesContent":["@import \"@/constants/colors\";\n\n.RenderRowTabAttributesTable {\n    display: flex;\n    align-items: center;\n    background-color: $white;\n    max-height: calc(100vh - 421px);\n    overflow: auto;\n    &:hover {\n        background-color: $light-gray;\n        text-decoration-line: underline;\n        cursor: pointer;\n        div {\n            div {\n                opacity: 1;\n                transition: opacity 0.2s ease-in-out;\n            }\n        }\n        &__titleFirst + &__titleSecond + &__titleThird {\n            text-decoration: underline;\n        }\n    }\n}\n.RenderRowTabAttributesTable__titleFirst {\n    width: 29px;\n    font-family: Raleway;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n    display: table-cell;\n    vertical-align: inherit;\n    text-align: left;\n    padding: 16px;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n}\n.RenderRowTabAttributesTable__titleSecond {\n    width: 100%;\n    font-family: Raleway;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n    display: table-cell;\n    vertical-align: inherit;\n    text-align: left;\n    padding: 16px;\n    font-style: normal;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 16px;\n}\n.RenderRowTabAttributesTable__titleThird {\n    font-family: Raleway;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.43;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n    display: table-cell;\n    text-align: left;\n    border: 0px;\n    color: inherit;\n    vertical-align: middle;\n    div {\n        p {\n            width: 29px;\n            text-align: center;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n    }\n}\n.RenderRowTabAttributesTable__titleFourth {\n    font-family: Raleway;\n    font-weight: 400;\n    font-size: 0.875rem;\n    line-height: 1.43;\n    text-transform: none;\n    font-feature-settings: \"lnum\";\n    display: table-cell;\n    text-align: left;\n    border: 0px;\n    color: inherit;\n    padding: 8px 16px;\n    vertical-align: middle;\n}\n","$black: #000000;\n$white: #ffffff;\n$grey: #6e6e6e;\n$slightly_grey: #e6e6e6;\n$light-gray: #def3db;\n$gray_smoke: #bdbdbd;\n$red: #ff0000;\n$heavenly: #61dafb;\n$granite_grey: #282c34;\n$periwinkle_crayola: #f1f9f7;\n$pale_blue: #d7d7d8;\n$dull_grey: #616161;\n$emerald: #5dc689;\n$light_green: #1dc255;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"RenderRowTabAttributesTable": `RenderRowTabAttributesTable_RenderRowTabAttributesTable__H5Kqm`,
	"RenderRowTabAttributesTable__titleFirst": `RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleFirst__HT-sn`,
	"RenderRowTabAttributesTable__titleSecond": `RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleSecond__WzcKM`,
	"RenderRowTabAttributesTable__titleThird": `RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleThird__mSVNI`,
	"RenderRowTabAttributesTable__titleFourth": `RenderRowTabAttributesTable_RenderRowTabAttributesTable__titleFourth__JuWTu`
};
export default ___CSS_LOADER_EXPORT___;
